// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { UserBalanceQueryDocument, type UserBalanceQuery, type UserBalanceQueryVariables } from './UserBalanceQuery';

export async function getUserBalanceQueryClient(variables: UserBalanceQueryVariables) {
  return fetchGraphqlClient<UserBalanceQuery, UserBalanceQueryVariables>(UserBalanceQueryDocument, "UserBalanceQuery", { variables });
}
export const useUserBalanceQuery = (...args: QueryArgs<UserBalanceQueryVariables>) => useQuery<UserBalanceQuery, UserBalanceQueryVariables>(getUserBalanceQueryClient, ...args);